var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.errorObj
    ? _c("section", { staticClass: "error-page" }, [
        _c(
          "div",
          { staticClass: "error-page__wrapper" },
          [
            _c("h2", { staticClass: "error-page__code" }, [
              _vm._v(_vm._s(_vm.errorObj.title))
            ]),
            _vm.errorObj.description
              ? _c("BaseCaption", {
                  staticClass: "error-page__message",
                  attrs: { text: _vm.errorObj.description }
                })
              : _vm._e(),
            _c(
              "div",
              { staticClass: "error-page__btns" },
              [
                _c("BaseBtn", {
                  attrs: {
                    customClass: "default-text",
                    text: _vm.errorObj.leftButtonText,
                    to: "/"
                  }
                }),
                _c("BaseBtn", {
                  attrs: {
                    customClass: "default-text",
                    text: _vm.errorObj.rightButtonText,
                    to: "/participants-page"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5ea9138", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5ea9138","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/error.vue
// module id = PiST
// module chunks = 13